module.exports = __webpack_public_path__ + "img/comfort.ecfa64f9.svg";